<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">财务管理</span>
    </div>
    <div style="padding:0px 20px 0px 24px">
      <div
        class="flex_between_nowrap"
        style="margin-top:20px;margin-bottom:30px"
      >
        <div>
          <el-input
            clearable
            placeholder="请输入资产名称/编码/分类"
            size="small"
            v-model="params['search']"
            style="width:300px;"
          >
            <i
              slot="suffix"
              class="el-icon-search inputIcon "
              @click.stop="tableSearch"
            ></i>
          </el-input>
        </div>
        <div class="flex_end">
          <el-button
            type="main"
            icon="iconfont icon-a-Advancedsearch Advancedsearch"
            style="width:120px;margin-right:10px"
            @click="moveSearch"
            >高级搜索</el-button
          >
          <el-button type="submit" @click="export_click">导出</el-button>
        </div>
      </div>

      <div class="totalbox">
        <div v-for="item in totalArr" :key="item.model">
          <span>{{ item.label + ":" }}</span
          ><span>{{ totalmodel[item.model] }}</span>
        </div>
      </div>
      <x-table
        :isshowsize="true"
        url="/pc/finance/page"
        ref="xTable"
        :axiosType="true"
        :params="params"
      >
        <el-table-column
          :label="item.label"
          :prop="item.model"
          show-overflow-tooltip
          v-for="item in columnArr"
          :key="item.model"
        >
          <template slot-scope="scope">
            <span v-if="item.model == 'deprType'">{{
              deprType_fulter(scope.row[item.model])
            }}</span>
            <div style="width:100%" v-else-if="item.model == 'assetStatus'">
              <el-tag
                :style="assetStatusFulter(scope.row[item.model], false)"
                >{{ assetStatusFulter(scope.row[item.model], true) }}</el-tag
              >
            </div>
            <span v-else-if="item.model == 'deadline'">{{
              scope.row[item.model]
                ? scope.row[item.model] + deadline_fulter(scope.row["deprType"])
                : ""
            }}</span>
            <span v-else>{{ scope.row[item.model] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
           <el-button type="text" class="addColor" @click="detals(scope.row.id)">折旧详情</el-button>
          </template>
        </el-table-column>
      </x-table>
    </div>
    <!-- 高级搜索 -->
    <el-drawer
      append-to-body
      title="高级搜索"
      size="360px"
      modal
      :visible.sync="moveDrawer"
      :before-close="closeDeawer"
      direction="rtl"
    >
    <div class="x-drawer-append-body">
      <div  class="x-drawer-append-main">
        <el-form
          class="elFormClass"
          :model="params"
          ref="ruleForm"
          label-width="auto"
          size="small"
        >
          <el-form-item
            v-for="(item, index) in searchItems"
            :label="item.label"
            :key="index"
          >
            <el-select
              clearable
              v-if="
                item.model == 'assetStatus' ||
                  item.model == 'unReturn' ||
                  item.model == 'unDispose'
              "
              style="width:100%"
              v-model="params[item.model]"
              :placeholder="`请选择` + item.label"
            >
              <el-option
                v-for="(s, si) in item.options"
                :key="si"
                :label="s.label"
                :value="s.model"
              >
              </el-option>
            </el-select>
            
            <x-Treeselect
            :load-options="loadOptions"
              style="width:100%"
              :placeholder="'请选择' + item.label"
              v-else-if="
                item.model == 'assetClassify'
              "
              v-model="params[item.model]"
              :clearable="true"
              :multiple="false"
              :options="classifyArr"
              value="id"
              label="cName"
              id="id"
            ></x-Treeselect>
            <x-Treeselect
              style="width:100%"
              :defaultExpandLevel="Infinity"
              :placeholder="'请选择' + item.label"
              v-else-if="
                  item.model == 'deptId' ||
                  item.model == 'useDeptId'
              "
              v-model="params[item.model]"
              :clearable="true"
              :multiple="false"
              :options="treeType(item.model)"
              value="id"
              label="cName"
              id="id"
            ></x-Treeselect>
            <x-select
              v-else-if="item.model == 'areaId' || item.model == 'depositArea'"
              :placeholder="'请选择' + item.label"
              ref="area"
              style="flex:1;"
              :label="item.optionslabel"
              :model="item.optionsmodel"
              v-model="params[item.model]"
              :url="item.url"
              :params="item.params"
            ></x-select>
            <el-input
              @focus="assetAdminFocus"
              clearable
              @clear="assetAdminclear"
              v-else-if="item.model == 'assetAdminName'"
              :placeholder="'请选择' + item.label"
              v-model="params[item.model]"
            ></el-input>
            <el-input
              @focus="usePersonFocus"
              clearable
              @clear="usePersonclear"
              v-else-if="item.model == 'usePersonName'"
              :placeholder="'请选择' + item.label"
              v-model="params[item.model]"
            ></el-input>
            <div
              v-else-if="item.label == '价格范围'"
              class="flex_between_nowrap"
            >
              <el-input-number
                clearable
                :controls="false"
                :min="0"
                :precision="2"
                v-model="params[item.modelLeft]"
                style="width:130px"
                :placeholder="`请输入` + item.label"
              ></el-input-number>
              <span>至</span>
              <el-input-number
                clearable
                :controls="false"
                :min="0"
                :precision="2"
                v-model="params[item.modelRight]"
                style="width:130px"
                :placeholder="`请输入` + item.label"
              ></el-input-number>
            </div>
            <el-date-picker
              clearable
              v-else-if="item.label == '日期范围'"
              v-model="pickerArr"
              @change="pickerChange"
              style="width:100%"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            >
            </el-date-picker>
            <el-input clearable v-else v-model="params[item.model]"></el-input>
          </el-form-item>
        </el-form>
      
      </div>
      <div class="dialog_bottom">
          <el-button
            class="dialog_close"
            size="small"
            type="main"
            @click="close"
            >取 消</el-button
          >
          <el-button
            class="dialog_submit"
            size="small"
            style="width:100px"
            type="submit"
            @click="submit"
            >查 询</el-button
          >
        </div>
    </div>
   
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      totalmodel: {},
      totalArr: [
        {
          label: "总数量",
          model: "sumCount",
        },
        {
          label: "总价值",
          model: "sumPrice",
        },
        {
          label: "总残值",
          model: "residuePrice",
        },
        {
          label: "维修支出",
          model: "repairPrice",
        },
        {
          label: "处置数量",
          model: "disposeCount",
        },
        {
          label: "处置收入",
          model: "disposePrice",
        },
      ],
      set_columnItem: {},
      selectArr: [],
      pickerArr: [],
      classifyArr: [],
      deptArr: [],
      searchItems: [
        {
          label: "状态",
          model: "assetStatus",
          options: [
            {
              label: "不限",
              model: null,
            },
            {
              label: "闲置",
              model: "idle",
            },
            {
              label: "在用",
              model: "use",
            },
            {
              label: "借用",
              model: "borrow",
            },
            {
              label: "维修中",
              model: "repair",
            },
            {
              label: "已处置",
              model: "dispose",
            },
            {
              label: "审批中",
              model: "examine",
            },
          ],
        },
        {
          label: "资产分类",
          model: "assetClassify",
        },
        {
          label: "所属组织",
          model: "deptId",
        },
        {
          label: "所在区域",
          model: "areaId",
          url: "/pc/area/page",
          optionslabel: "aName",
          optionsmodel: "id",
          params: {size:9999},
        },
        {
          label: "管理人员",
          model: "assetAdminName",
        },
        {
          label: "使用组织",
          model: "useDeptId",
        },
        {
          label: "使用人员",
          model: "usePersonName",
          optionslabel: "staffName",
          optionsmodel: "id",
          url: "/pc/admin/page",
          params: { type: "all" },
        },
        {
          label: "存放区域",
          model: "depositArea",
          url: "/pc/area/page",
          optionslabel: "aName",
          optionsmodel: "id",
          params: {size:9999},
        },
        {
          label: "规格型号",
          model: "spec",
        },
        {
          label: "价格范围",
          modelLeft: "minPrice",
          modelRight: "maxPrice",
        },
        {
          label: "日期范围",
        },
        {
          label: "其他状态",
          model: "unReturn",
          options: [
            {
              label: "所有",
              model: false,
            },
            {
              label: "已到期未归还",
              model: true,
            },
          ],
        },
        {
          label: "其他状态",
          model: "unDispose",
          options: [
            {
              label: "所有",
              model: false,
            },
            {
              label: "已到期未处置",
              model: true,
            },
          ],
        },
        {
          label: "供应商",
          model: "supplier",
        },
      ],

      moveDrawer: false,
      params: {
        assetStatus: null,
        unDispose: false,
        unReturn: false,
      },
      defaultParams: {
        assetStatus: null,
        unDispose: false,
        unReturn: false,
      },
      columnArr: [
        {
          label: "状态",
          model: "assetStatus",
        },
        {
          label: "资产编码",
          model: "assetCode",
        },
        {
          label: "资产名称",
          model: "assetName",
        },
        {
          label: "所属部门",
          model: "deptName",
        },
        {
          label: "使用部门",
          model: "useDeptName",
        },
        {
          label: "使用人",
          model: "usePersonName",
        },
        {
          label: "入库日期",
          model: "inTime",
        },
        {
          label: "价值",
          model: "price",
        },

        {
          label: "剩余残值",
          model: "residuePrice",
        },
        {
          label: "处置收入",
          model: "disposePrice",
        },
        {
          label: "维修支出",
          model: "repairPrice",
        },
        {
          label: "折旧类型",
          model: "deprType",
        },
        {
          label: "残值率(%)",
          model: "salvage",
        },
        {
          label: "预计可用",
          model: "deadline",
        },
        {
          label: "月工作量",
          model: "monthCount",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    detals(id){
     this.$createDialog(this, {
        dialogConfig: { title: "资产信息-折旧详情", width: "50%" },
        namespace: "page_details",
        whetherDestruction: true,

        assemblyConfig: {
          id
        },
      });
    },
    export_click() {
      this.$createDialog(this, {
        dialogConfig: { title: "资产信息导出", width: "50%" },
        namespace: "page_export",
        whetherDestruction: true,

        assemblyConfig: {
        },
      });
    },
    assetStatusFulter(data, flag) {
      let str = "";
      if (flag) {
        switch (data) {
          case "idle":
            str = "闲置";

            break;

          case "use":
            str = "在用";

            break;
          case "borrow":
            str = "借用";

            break;
          case "repair":
            str = "维修中";

            break;
          case "dispose":
            str = "处置";

            break;
          case "examine":
            str = "审批中";

            break;
        }
      } else {
        switch (data) {
          case "use":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "borrow":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "examine":
            str = "color:#436bff;background:#d8e6ff;";

            break;

          case "idle":
            str = "color:#42b983;background:#f0f9eb;";

            break;
          case "dispose":
            str = "color:#ffa200;background:#ffefd8;";
            break;
          case "repair":
            str = "color:#ffa200;background:#ffefd8;";
            break;
        }
      }
      return str;
    },

    deadline_fulter(data) {
      let a = "";
      switch (data) {
        case null:
          a = "";
          break;
        case "straight":
          a = "月";
          break;
        case "decrease":
          a = "年";

          break;
        case "yeartotal":
          a = "年";

          break;
        case "workload":
          a = "次";

          break;
        default:
          a = "";
      }
      return a;
    },

    deprType_fulter(data) {
      let a = "";
      switch (data) {
        case null:
          a = "无";
          break;
        case "straight":
          a = "年限平均法";

          break;
        case "workload":
          a = "工作量法";

          break;
        case "decrease":
          a = "双倍余额递减法";

          break;
        case "yeartotal":
          a = "年数总和法";

          break;
        default:
          a = "无";
      }
      return a;
    },

    usePersonCallBack(data) {
      if (data.id) {
        this.$set(this.params, "usePersonName", data.staffName);
        this.$set(this.params, "usePerson", data.id);
      }
    },
    usePersonclear() {
      this.$set(this.params, "usePersonName", "");
      this.$set(this.params, "usePerson", "");
    },
    usePersonFocus() {
      this.$createDialog(this, {
        dialogConfig: { title: "选择人员", width: "50%" },
        namespace: "select_account",
        whetherDestruction: true,

        assemblyConfig: {
          queryType: "admin",
          callBack: this.usePersonCallBack,
        },
      });
    },
    assetAdminCallBack(data) {
      if (data.id) {
        this.$set(this.params, "assetAdminName", data.staffName);
        this.$set(this.params, "assetAdmin", data.id);
      }
    },
    assetAdminclear() {
      this.$set(this.params, "assetAdminName", "");
      this.$set(this.params, "assetAdmin", "");
    },
    assetAdminFocus() {
      this.$createDialog(this, {
        dialogConfig: { title: "选择人员", width: "50%" },
        namespace: "select_account",
        whetherDestruction: true,

        assemblyConfig: {
          queryType: "admin",
          callBack: this.assetAdminCallBack,
        },
      });
    },
    handleSelectionChange(data) {
      this.selectArr = data;
    },
    handleCommand(data) {
      if (
        this.selectArr.length ||
        data == "export" ||
        data == "dowTemp" ||
        data == "upload"
      ) {
        let flag = true;
        let ids = [];
        /* return 在用 use  */
        /* change 在用 use  借用 borrow 闲置 idle   */
        /* repair 在用 use  借用 borrow 闲置 idle   */

        switch (data) {
          case "upload":
            this.createDialogType(
              { width: "420px", title: "资产导入" },
              `asset_list_${data}`,
              {
                callBack: this.tableSearch,
              }
            );

            break;
          case "dowTemp":
            this.createDialogType(
              { width: "360px", title: "模板下载" },
              `asset_list_export`,
              { dowloadType: false }
            );

            break;

          case "export":
            this.createDialogType(
              { width: "360px", title: "资产导出" },
              `asset_list_${data}`,
              {}
            );

            break;
          case "edit":
            for (let i = 0; i < this.selectArr.length; i++) {
              ids.push(this.selectArr[i].id);
            }

            this.createDialogType(
              { width: "860px", title: "资产批量编辑" },
              `asset_list_${data}`,
              {
                editData: this.selectArr,
                ids,
                callBack: this.tableSearch,
              }
            );

            break;

          case "repair":
            for (let i = 0; i < this.selectArr.length; i++) {
              ids.push(this.selectArr[i].id);
              if (
                this.selectArr[i].assetStatus != "use" &&
                this.selectArr[i].assetStatus !== "borrow" &&
                this.selectArr[i].assetStatus !== "idle"
              ) {
                flag = false;
                break;
              }
            }

            if (flag) {
              this.createDialogType(
                { width: "360px", title: "资产批量维修" },
                `asset_list_${data}`,
                {
                  ids,
                  callBack: this.tableSearch,
                }
              );
            } else {
              this.$success(
                "操作失败：状态为/在用/借用/闲置,才能进行资产维修!",
                "error"
              );
            }

            break;

          case "change":
            for (let i = 0; i < this.selectArr.length; i++) {
              ids.push(this.selectArr[i].id);
              if (
                this.selectArr[i].assetStatus != "use" &&
                this.selectArr[i].assetStatus !== "borrow" &&
                this.selectArr[i].assetStatus !== "idle"
              ) {
                flag = false;
                break;
              }
            }

            if (flag) {
              this.createDialogType(
                { width: "780px", title: "资产批量变更" },
                `asset_list_${data}`,
                {
                  changeData: this.selectArr,
                  ids,
                  callBack: this.tableSearch,
                }
              );
            } else {
              this.$success(
                "操作失败：状态为/在用/借用/闲置,才能进行资产变更!",
                "error"
              );
            }

            break;
          case "return":
            for (let i = 0; i < this.selectArr.length; i++) {
              ids.push(this.selectArr[i].id);
              if (this.selectArr[i].assetStatus != "use") {
                flag = false;
                break;
              }
            }

            if (flag) {
              this.createDialogType(
                { width: "360px", title: "领用批量退还" },
                `asset_list_${data}`,
                {
                  ids,
                  callBack: this.tableSearch,
                }
              );
            } else {
              this.$success(
                "操作失败：状态为‘在用’下,才能进行领用退还!",
                "error"
              );
            }

            break;
        }
      } else {
        this.$success("操作失败：请选择数据后使用!", "error");
      }
    },
    submit() {
      this.$refs.xTable.formParams.current = 1;
      this.moveDrawer = !this.moveDrawer;
      this.tableSearch();
    },
    close() {
      let flag = false;
      for (let key in this.params) {
        if (this.params[key]) {
          flag = true;
          break;
        }
      }
      if (flag) {
        this.$alertMsg.confirm(
          `您将丢失未保存的内容,确定继续吗`,
          () => {
            this.params = JSON.parse(JSON.stringify(this.defaultParams));

            this.moveDrawer = !this.moveDrawer;
            setTimeout(() => {
              this.tableSearch();
            });
            return;
          },
          () => {
            setTimeout(() => {
              this.tableSearch();
            });
          }
        );
      } else {
        this.moveDrawer = !this.moveDrawer;
        setTimeout(() => {
          this.tableSearch();
        });
      }
    },
    closeDeawer(done) {
      let flag = false;
      for (let key in this.params) {
        if (this.params[key]) {
          flag = true;
          break;
        }
      }
      if (flag) {
        this.$alertMsg.confirm(`您将丢失未保存的内容,确定继续吗`, () => {
          this.params = JSON.parse(JSON.stringify(this.defaultParams));
          done();
          setTimeout(() => {
            this.tableSearch();
          });
          return;
        });
      } else {
        done();
        setTimeout(() => {
          this.tableSearch();
        });
        return;
      }
    },
    pickerChange(data) {
      if (data) {
        this.params.minTime = data[0];
        this.params.maxTime = data[1];
      } else {
        this.params.minTime = "";
        this.params.maxTime = "";
      }
    },
    treeType(model) {
      let arr = [];
      switch (model) {
   
        case "deptId":
          arr = this.deptArr;
          break;
        case "useDeptId":
          arr = this.deptArr;

          break;
      }
      return arr;
    },

    get_total() {
      this.$requestAxiosForm(
        {
          url: "/pc/finance/statistics",
          data: this.params,
        },
        (data) => {
          this.totalmodel = data.data;
        }
      );
    },
    init() {
      this.get_total();
      this.$requestAxios(
        {
          url: "/pc/print/getSelect",
          data: {},
        },
        (data) => {
          for (let key in data.data) {
            if (key !== "not") {
              data.data[key] = data.data[key].substring(
                0,
                data.data[key].indexOf(":") == -1
                  ? data.data[key].length + 1
                  : data.data[key].indexOf(":") + 1
              );
            }
          }
          this.set_columnItem = data.data;
        }
      );
      this.getClassifyArr();
      this.getDeptArr();
    },

    /* 递归处理空的children */
    treelabelFulter(arr, label) {
      arr.forEach((item) => {
        item.label = item[label];
        if (item.children == [] || item.children == "") {
          delete item.children;
        }
        if (item.children && item.children.length) {
          this.treelabelFulter(item.children, label);
        }
      });
    },
    loadOptions({ action, parentNode, callback }) {
      console.log(action, parentNode, callback);
      this.$requestAxios(
        {
          url: "/pc/classify/page",
          data: { pId: parentNode.id },
        },
        (data) => {
          let newData = data.data || [];
          let result = newData.map((item) => {
            item.label = item.cName;
            item.children = null;
            return item;
          });
          parentNode.children = result;
          callback();
        }
      );
    },
    /* 资产分类page */
    getClassifyArr() {
      this.$requestAxios(
        {
          url: "/pc/classify/page",
          data: { pId: "0" },
        },
        (data) => {
          let newData = data.data || [];
          let result = newData.map((item) => {
            item.label = item.cName;
            item.children = null;
            return item;
          });
          this.classifyArr = result;
        }
      );
    },

    /* 所属组织  使用组织 */
    getDeptArr() {
      this.$requestAxios(
        {
          url: "/pc/dept/tree",
          data: {},
        },
        (data) => {
          this.treelabelFulter(data.data, "deptName");
          this.deptArr = data.data;
        }
      );
    },
    moveSearch() {
      this.moveDrawer = !this.moveDrawer;
    },
    createDialogType(dialogConfig = {}, namespace, assemblyConfig = {}) {
      this.$createDialog(this, {
        dialogConfig,
        namespace,
        whetherDestruction: true,

        assemblyConfig,
      });
    },

    tableSearch() {
      this.$refs.xTable.search();
      this.get_total();

    },
  },
};
</script>
<style scoped lang="less">
.x-drawer-append-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  height: 100%;
  .x-drawer-append-main {
    padding: 8px 30px 22px 30px;
    box-sizing: border-box;
    overflow: auto;
    flex: 1;

  }
  .dialog_bottom {
    width: 100%;
    flex-shrink: 0;
    height: 80px;
    padding-right: 30px;
    border-top: 1px solid #e0e0e0;
    box-sizing: border-box;

  }
}
.totalbox {
  padding: 0px 100px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.totalbox > div {
  flex: 1;
}
.totalbox > div > span:first-child {
  font-size: 14px;
  color: #1e1e1e;
  font-weight: bold;
  display: inline-block;
}
.totalbox > div > span:last-child {
  text-indent: 10px;
  font-size: 14px;
  letter-spacing: 0px;
  display: inline-block;
  font-weight: bold;

  color: #436bff;
}
</style>
